import React from "react";
import { appIconService } from "../../..";

type Props = {
  appRolePrefix: string;
  className?: string;
};

export default class AppIcon extends React.Component<Props> {
  render() {
    return (
      <img
        className={this.props.className}
        src={appIconService.getIconPathForApp(this.props.appRolePrefix)}
      />
    );
  }
}
